module.exports = __webpack_public_path__ + "img/logo3.81be08e4.png";